var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGalaxis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 860.516,
    height: 204.228,
    viewBox: "0 0 860.516 204.228",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Galaxis_black",
    transform: "translate(-185.621 -308.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M1041.8,419.1a28.588,28.588,0,0,0-11.4-7.9,163.19,163.19,0,0,0-17.6-5.3q-9.15-2.25-14.7-4.2a24.393,24.393,0,0,1-9.1-5.5,12.974,12.974,0,0,1-3.6-9.6,15.706,15.706,0,0,1,6.6-13c4.4-3.3,10.9-5,19.6-5a48.867,48.867,0,0,1,13.9,2.1,47.434,47.434,0,0,1,13.3,6.2l3.5-8.4a48.065,48.065,0,0,0-14.1-6.4,58.366,58.366,0,0,0-16.6-2.3c-8.1,0-14.9,1.2-20.4,3.7s-9.5,5.7-12.2,9.8a25.222,25.222,0,0,0-4,13.7c0,6.1,1.6,11,4.7,14.6a29.224,29.224,0,0,0,11.4,8,146.889,146.889,0,0,0,17.8,5.4,136.535,136.535,0,0,1,14.6,4.2,25.136,25.136,0,0,1,8.8,5.4,12.739,12.739,0,0,1,3.6,9.5c0,5.2-2.2,9.4-6.7,12.7-4.4,3.3-11.1,4.9-20,4.9a52.513,52.513,0,0,1-18.4-3.3,39.383,39.383,0,0,1-14.3-8.7l-4.1,8.1q5.55,5.85,15.6,9.3a62.465,62.465,0,0,0,21.2,3.5c8.1,0,15-1.2,20.5-3.6,5.6-2.4,9.7-5.7,12.4-9.8a24.406,24.406,0,0,0,4-13.7c.3-6-1.2-10.8-4.3-14.4",
    fill: "#010202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M557.2,360.6l-45.3,99.1H523l28.5-10.6H527.7l34.8-77.6L602,459.7h10.9l-45.3-99.1Z",
    fill: "#010202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M836.2,459.7h12.1l30.9-42.4-18.7,9.5Z",
    fill: "#010202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M891.5,401.6l30.1-41H910.3l-29.8,40.5-29.8-40.5H838.6l35.2,48Z",
    fill: "#010202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M880.5,416.6l31.6,43.1h12.2l-35.1-47.5Z",
    fill: "#010202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M941.4,382.1l10.5-4V360.6H941.4Z",
    fill: "#010202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M941.4,459.7h10.5V380.3l-10.5,5.4Z",
    fill: "#010202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M764.2,360.6l-45.3,99.1H730l28.5-10.6H734.7l34.8-77.6L809,459.7h10.9l-45.3-99.1Z",
    fill: "#010202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M441.4,374.4a44.969,44.969,0,0,1,21.7-5.3c12.1,0,22,3.9,29.9,11.6l6.5-6.7a41.4,41.4,0,0,0-16-10.7,58.245,58.245,0,0,0-20.8-3.6,55.466,55.466,0,0,0-26.9,6.5,47.861,47.861,0,0,0-18.7,18.1,52.344,52.344,0,0,0,0,51.6,47.612,47.612,0,0,0,18.7,18,55.073,55.073,0,0,0,26.8,6.5,60.8,60.8,0,0,0,20-3.3,49.7,49.7,0,0,0,16.4-9.3V418.5L488.9,423v20.4c-7.1,5.1-15.7,7.6-25.9,7.6a43.937,43.937,0,0,1-21.7-5.4,39.505,39.505,0,0,1-15.1-14.7,40.152,40.152,0,0,1-5.5-21,40.659,40.659,0,0,1,5.5-21,39.28,39.28,0,0,1,15.2-14.5",
    fill: "#010202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M643.4,360.6h-.1l.1.1Z",
    fill: "#010202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M643.4,361l-10.5,4.7v94h66v-9.1H643.4Z",
    fill: "#010202"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M327.5,370a40.2,40.2,0,0,1,15.7,10.8A43.091,43.091,0,0,1,320.8,452c-17.1,4-35.9-3.7-45.8-19.2-5.2-8.2-12.2-12.4-22-11.9-11.1.6-20.9,10.5-21.4,21.5-.5,12.6,7.7,23.2,19.5,24.7,3,.4,6.1-.2,9.1-.3.8,0,1.8-.2,2.4.2,5.8,3.9,11.5,8,17.3,12a40.946,40.946,0,0,1-17.5,7.4,42.9,42.9,0,0,1-49.8-33.8c-4.8-23,10.4-46.1,33.4-50.7,3.1-.6,6.3-.8,9.4-1.1,9.4-.8,16.1-5.6,19.6-14.3,3.5-8.8,2.1-17-4.2-24.1-6.2-7-14.2-9.5-23.2-7.1s-14.6,8.5-16.9,17.5a3.592,3.592,0,0,1-1.5,2.1c-5.7,3-11.5,5.9-17.3,8.7a6.374,6.374,0,0,1-.9.2,41.989,41.989,0,0,1,3.4-24,43,43,0,0,1,69.3-12.7c12.9,12.6,16.4,31.7,9,48.5-.8,1.7-1.5,3.4-2.4,5.1-6.1,12.1,1.2,28.4,16.3,31.8a23.484,23.484,0,0,0,25.7-12.2c4.9-9.4,2.8-20.5-5.2-27.9a3.7,3.7,0,0,1-1.2-2.5c.3-6.4.8-12.8,1.3-19.1A1.578,1.578,0,0,0,327.5,370Z",
    fill: "#010202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M317.4,394.3c7,3.4,10.9,8.8,10.6,16.8-.4,8.3-7.9,15.3-16.3,15.3-8.7,0-16.4-6.9-16.4-15.3a19.823,19.823,0,0,1,2.1-9.3c9.7-17.8,7.9-40.2-5.4-55.7-13.4-15.6-30.6-21.5-50.5-16.5-19.7,5-31.9,18.2-36.5,38-1.5,6.2-.8,12.6.6,18.8a3.208,3.208,0,0,1-.5,2.7c-4.3,4.7-8.8,9.3-13.1,13.8-8.5-14.9-10.5-44.4,6.6-67.5A67.529,67.529,0,0,1,278.4,313C301.9,322.6,328.2,352.1,317.4,394.3Z",
    fill: "#010202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M307.4,485.8a65.549,65.549,0,0,1-17.5,16.1c-40.3,25.5-94.3,1.4-102-45.7-5.6-33.5,14.2-65.4,46.9-75.5,1.8-.5,2.4-1.2,2.4-3.1a16.433,16.433,0,0,1,32.8-1.1c.7,9.1-5.4,17-14.3,17.8-7.3.6-14.4,1.5-21.1,4.5-19.8,8.9-31.9,30-29.3,51.2a49.878,49.878,0,0,0,41.6,43.5c14.7,2.3,27.8-1.3,39.4-10.5a3.959,3.959,0,0,1,3.9-.8C295.7,483.4,301.4,484.5,307.4,485.8Z",
    fill: "#010202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M320.2,343.5c23.5,2.5,48.8,20.3,56.3,49.9A67.151,67.151,0,0,1,346.8,467c-24.1,15.1-58.1,14.4-82.6-9-5.6,3.3-11.4,3.7-17.3.6a16.39,16.39,0,0,1-8.3-17.3c1-6.6,6.4-12,13.5-13.4,6.3-1.3,13.4,1.9,16.9,7.7,9.5,15.5,23.6,23.7,41.6,24.2a49.384,49.384,0,0,0,50.3-42.2c3.4-24.2-9.7-46.1-32.7-54.5a3.3,3.3,0,0,1-2.5-3,65.6,65.6,0,0,0-2.3-8.4C322.4,348.9,321.3,346.3,320.2,343.5Z",
    fill: "#010202"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalaxis);
export default __webpack_public_path__ + "static/media/galaxis.0c40e9e470a2b45a9ce018761a8a80f7.svg";
export { ForwardRef as ReactComponent };